import FlowioColorInput from "./FlowioColorInput";

export default FlowioColorInput;
export type { FlowioColorInputProps } from "./FlowioColorInput";
